export default __webpack_public_path__ + "static/media/IOS.401e8814.svg";